export const WEB_USERS_LABEL = 'Web users'
export const DEF_PERIOD = 3600
